$(document).ready(function () {
  $(".navbar").addClass("non-home");
  $(".navbar").removeClass("bg-transparent");
  $(".navbar").addClass("bg-white");
  $(".navbar").addClass("border-bottom");
              $("#share_link").click(function (e) {
                e.preventDefault();
  // Get the text field
  var copyText = document.getElementById("url");

  // Select the text field
  copyText.select();
  copyText.setSelectionRange(0, 99999); // For mobile devices

  // Copy the text inside the text field
  navigator.clipboard.writeText(copyText.value);
  
                
            });
            $("#detailsDropdown").click(function (e) {
                e.preventDefault();
                $("#details").slideToggle();
                $("#detailsChevron svg").toggleClass("rotate-180");
            });
            $("#shippingDropdown").click(function (e) {
                e.preventDefault();
                $("#details4").slideToggle();
                $("#detailsChevron4 svg").toggleClass("rotate-180");
            });
            $("#shipping").click(function (e) {
                e.preventDefault();
                $("#details2").slideToggle();
                $("#detailsChevron2 svg").toggleClass("rotate-180");
            });
            $("#care").click(function (e) {
                e.preventDefault();
                $("#details3").slideToggle();
                $("#detailsChevron3 svg").toggleClass("rotate-180");
            });
});

var sidebar = new StickySidebar('#sticky', {topSpacing: 20});